module.exports = __webpack_public_path__ + "static/media/Age of the Gods Norse_ Gods and Giants.3b66b49f.png";